<template>
  <div style="width: 100%">
    <Form ref="item" :model="item" :label-width="80">
      <Row>
        <Col span="8"
          ><FormItem label="工单号">
            {{ item.no }}
          </FormItem></Col
        >
        <Col
          :span="x.span ? x.span : 8"
          v-for="(x, index) in forms"
          :key="index"
        >
          <FormItem :label="x.title"
            ><template v-if="x.show">
              <template v-if="x.show == 'yymmdd'">{{
                utils.time(item[x.key], "yymmdd")
              }}</template
              ><template v-if="x.show == 'arr' && x.selectType != 'obj'">
                {{ utils.isEmpty(item[x.key]) ? "" : item[x.key].join(" / ") }}
              </template>
              <template v-if="x.show == 'photo' && item[x.key]">
                <viewer>
                  <img
                    v-for="(y, index1) in item[x.key]"
                    :key="index1"
                    :src="axios.platConfig.fileUri + y"
                    width="30"
                    height="30"
                    style="margin-right: 4px; cursor: pointer"
                  />
                </viewer>
              </template>
            </template>
            <template v-else>
              <a @click="open(item[x.key])" v-if="x.open">{{ item[x.open] }}</a>
              <template v-else>{{
                item[x.key1] ? item[x.key1] : item[x.key]
              }}</template>
            </template>
          </FormItem>
        </Col>
      </Row>
    </Form>
    <h4 style="margin-bottom: 10px">领导签字</h4>

    <Table :columns="columns" :data="tableData"></Table>
    <h3 style="margin-bottom: 10px; margin-top: 20px">附表：验收单</h3>
    <yanshoudoc ref="yanshoudoc"></yanshoudoc>
  </div>
</template>
<script>
import fields from "./forms/fields";
import yanshoudoc from "./yanshoudoc.vue";
export default {
  props: ["modal"],
  components: { yanshoudoc },
  data() {
    return {
      openForm: false,
      item: {
        address: "",
        content: "",
        groupId: "",
        groupName: "",
        name: "",
        time: "",
        time1: new Date(),
        carIdList: [],
        carId: "",
        carNo: "",
        cs: 2,
        dept: "",
        markerIdList: [],
        personIdList: [],
        remark: "",
        routeId: 0,
        x: 0,
        y: 0,
      },
      searchItem: {
        id: "",
      },
      serverUrl: "",
      forms: [],
      title: "",
      columns: [
        {
          title: "职务",
          key: "job",
        },
        {
          title: "姓名",
          key: "name",
        },
        {
          title: "时间",
          key: "time2",
          type: "yymmdd",
        },
        {
          title: "签字意见",
          key: "opinion",
        },
      ],
      tableData: [],
      asdads: false,
    };
  },
  methods: {
    reach(v) {
      this.openForm = true;
      this.searchItem.id = v.docId;
      this.getFormModel(v.formId);
    },
    readItem() {
      return this.item;
    },
    getDetail() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.serverUrl + "/item",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var data = res.data.data;
          console.log(res);
          if (data != null) {
            this.item = data;
            if (this.item.accept) {
              this.$refs.yanshoudoc.reach(this.item.accept);
            }

            var m = data.signList;
            for (let i = 0; i < m.length; i++) {
              m[i].time2 = this.utils.time(m[i].time);
            }
            this.tableData = data.signList;
          }
        }
      });
    },
    getFormModel(id) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.flow + "/form/info",
        data: { id },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var v = res.data.data;
          this.forms = fields[v.field];
          this.serverUrl = v.serverUrl;

          this.title = v.name;
          this.getDetail();
        }
      });
    },
    open(x) {
      console.log(x);
      var obj = {
        formId: 7,
        docId: x,
      };
      this.asdads = true;
      setTimeout(() => {
        this.$refs.docDetail.reach(obj);
      }, 0);
    },

    cancel() {
      this.asdads = false;
    },
  },
};
</script>
<style>
#secsldg {
  width: 100%;
}
#secsldg td {
  width: 25%;
  padding: 6px 6px;
}
#secsldg thead tr {
  background: #f1f8fd;
}
</style>


// WEBPACK FOOTER //
// src/components/yhgl/docDetail.vue